import { render, staticRenderFns } from "./compulsory_subject.vue?vue&type=template&id=760278f0&"
import script from "./compulsory_subject.vue?vue&type=script&lang=js&"
export * from "./compulsory_subject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports